import axios from "@/utils/request.js";
import qs from "qs"
var baseUrl = process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BASE_API
//  获取文件预览路径
const filePerviewPath = (data) => {
    let url = baseUrl + `/api/web-manager/file/manager/redirect/${data.fileObjId}/${data.downType}`
    return url
};
export {
    filePerviewPath,
}